let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5Q9X0")).then(() => parcelRequire('56b4I'));